import { Helmet } from "react-helmet";


interface MetaComponentProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogUrl?: string;
  twitterCard?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
  location?: {
    protocol: string;
    host: string;
  };
  schema?: any[];
}

const MetaComponent = (props: MetaComponentProps) => {
  const canonicalURL = props.location
    ? `${props.location.protocol}//${props.location.host}${window.location.pathname}`
    : "";

  return (
    <Helmet>
      <title>{props.title}</title>
      <meta name="description" content={props.description} />
      <meta name="keywords" content={props.keywords} />
      {props.location && <link rel="canonical" href={`${canonicalURL}`} />}

      {/* {props.schema && <JsonLd data={props.schema} />} */}
    </Helmet>
  );
};

const JsonLd = ({ data }: any) => {
  return data.map((schema: any, index: number) => {
    return (
      <script
        key={index}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    );
  });
};

export { MetaComponent };
export default MetaComponent;
